module.exports = __webpack_public_path__ + "web-icons.b1694eb27c56259cd581.woff";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/web-icons/web-icons.woff?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.woff?v=0.2.3
// module chunks = styles